{
  "clipBoard": {
    "copySuccess": "Скопировано успешно"
  }
}
